import { ADD_MEDIA_ID } from 'actions';

export function addMediaId(mediaId: string, mediaIdIndex: number) {
  return { mediaId, mediaIdIndex, type: ADD_MEDIA_ID };
}
